import { useEffect } from 'react';
import { useFormik } from 'formik';
import { isEmpty } from 'lodash';
import {
  useNowEstablishPageTypeStore,
  useEstablishStore,
  getBtnProps,
  TransitionBtn,
  reloadHandler,
} from 'views/components/pages/accountEstablishment/hooks';
import {
  EstablishPageType,
  consentTrustinitialValues,
  consentTrustOnSubmit,
  ConsentTrustFormikType,
  consentTrustValidation,
  formErrorScroll,
  scrollToTop,
} from 'views/utils/accountEstablish';
import { ButtonProps } from 'views/components/atoms/button';
import { useNavigate } from 'react-router-dom';

export const useConsentTrust = () => {
  const navigate = useNavigate();
  const { nowEstablishPageType, setNowEstablishPageType } = useNowEstablishPageTypeStore();

  const { param, add } = useEstablishStore();
  const initialValues = consentTrustinitialValues(param);
  const onSubmit = consentTrustOnSubmit(param, setNowEstablishPageType, add);

  const formik: ConsentTrustFormikType = useFormik({
    initialValues,
    validationSchema: consentTrustValidation,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit,
  });

  const nextButtonProps: ButtonProps = getBtnProps(TransitionBtn.NEXT);
  const prevButtonProps: ButtonProps = getBtnProps(TransitionBtn.PREV, () =>
    setNowEstablishPageType(EstablishPageType.ConsentSecurities),
  );
  useEffect(() => {
    scrollToTop();
    window.addEventListener('beforeunload', reloadHandler);
    return () => {
      window.removeEventListener('beforeunload', reloadHandler);
    };
  }, []);

  useEffect(() => {
    if (nowEstablishPageType === EstablishPageType.ConsentTrust) return;
    navigate(nowEstablishPageType.toString());
  }, [nowEstablishPageType]);

  useEffect(() => {
    if (isEmpty(formik.errors)) return;
    formErrorScroll();
  }, [formik.isSubmitting]);

  return {
    formik,
    buttonProps: {
      nextButtonProps,
      prevButtonProps,
    },
  };
};
